import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterControls = ({
  managedProfiles,
  selectedDependent,
  onDependentChange,
  dateRange,
  onDateRangeChange,
  selectedCategory,
  onCategoryChange
}) => {
  const categories = [
    { value: 'all', label: 'All Categories' },
    { value: 'pain', label: 'Pain' },
    { value: 'fatigue', label: 'Fatigue' },
    { value: 'mood', label: 'Mood' },
    { value: 'sleep', label: 'Sleep' },
    { value: 'digestive', label: 'Digestive' },
    { value: 'respiratory', label: 'Respiratory' },
    { value: 'other', label: 'Other' }
  ];

  const quickDateRanges = [
    { label: 'Last 7 Days', days: 7 },
    { label: 'Last 30 Days', days: 30 },
    { label: 'Last 90 Days', days: 90 }
  ];

  const handleQuickDateRange = (days) => {
    const end = new Date();
    const start = new Date();
    start?.setDate(start?.getDate() - days);
    
    onDateRangeChange({
      start: start?.toISOString()?.split('T')?.[0],
      end: end?.toISOString()?.split('T')?.[0]
    });
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic p-4 sm:p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} className="text-primary" strokeWidth={2} />
        <h2 className="text-lg font-heading font-semibold text-foreground">
          Filter Analytics
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Dependent User Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Dependent User
          </label>
          <select
            value={selectedDependent}
            onChange={(e) => onDependentChange(e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth"
          >
            <option value="all">All Dependents</option>
            {managedProfiles?.map((profile) => (
              <option key={profile?.id} value={profile?.id}>
                {profile?.name} ({profile?.relationship})
              </option>
            ))}
          </select>
        </div>

        {/* Category Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Symptom Category
          </label>
          <select
            value={selectedCategory}
            onChange={(e) => onCategoryChange(e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth"
          >
            {categories?.map((category) => (
              <option key={category?.value} value={category?.value}>
                {category?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Date Range Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Date Range
          </label>
          <div className="flex gap-2">
            <input
              type="date"
              value={dateRange?.start}
              onChange={(e) => onDateRangeChange({ ...dateRange, start: e?.target?.value })}
              className="flex-1 px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth"
            />
            <input
              type="date"
              value={dateRange?.end}
              onChange={(e) => onDateRangeChange({ ...dateRange, end: e?.target?.value })}
              className="flex-1 px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth"
            />
          </div>
        </div>
      </div>

      {/* Quick Date Range Buttons */}
      <div className="flex flex-wrap gap-2 mt-4">
        <span className="text-sm text-muted-foreground mr-2">Quick select:</span>
        {quickDateRanges?.map((range) => (
          <button
            key={range?.days}
            onClick={() => handleQuickDateRange(range?.days)}
            className="px-3 py-1 text-xs font-medium bg-primary/10 text-primary rounded-lg hover:bg-primary/20 transition-smooth focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background"
          >
            {range?.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterControls;